<template>
  <section class="container mx-auto py-6 md:py-15 flex flex-col md:flex-row">
    <div class="w-full md:w-1/2 my-auto flex flex-col">
      <h2
        class="section-heading mb-5 md:mb-8 w-full md:w-2/3 text-center md:text-left"
      >
        {{ ourPeople.attributes?.title }}
      </h2>
      <div class="hidden md:block text-center">
        <NuxtLink
          :to="ourPeople.attributes?.cta_url"
          title="Our People"
          class="btn btn-md md:btn-lg btn-primary-reverse w-max"
        >
          {{ ourPeople.attributes?.cta_wording }}
        </NuxtLink>
      </div>
    </div>
    <div class="w-full md:w-1/2 flex">
      <NuxtImg
        format="webp"
        srcset=""
        loading="lazy"
        :src="ourPeople.attributes?.image?.data?.[0]?.attributes?.url"
        :alt="ourPeople.attributes.title"
        :title="ourPeople.attributes.title"
        quality="100"
        class="m-auto w-full rounded-lg"
      />
    </div>
    <div class="md:hidden mx-auto text-center mt-8 md:mt-10">
      <NuxtLink
        :to="ourPeople.attributes?.cta_url"
        title="Our People"
        class="btn btn-md md:btn-lg btn-primary-reverse w-max mx-auto"
      >
        {{ ourPeople.attributes?.cta_wording }}
      </NuxtLink>
    </div>
  </section>
</template>

<script setup>
const isLoading = ref(true)

const ourPeople = ref([])

const getOurPeople = async () => {
  const { data, error, pending } = await useSuitmediaApiData(
    `/api/image-team`,
    {
      query: {
        'fields[0]': 'id',
        'fields[1]': 'cta_wording',
        'fields[2]': 'cta_url',
        'fields[3]': 'title',
        populate: 'image'
      }
    }
  )

  isLoading.value = pending.value

  if (error.value) {
    throw createError({
      statusCode: 404,
      message: `Our People does not exist`
    })
  }

  return data.value
}

const poeple = await getOurPeople()
ourPeople.value = poeple.data
</script>

<style lang="scss" scoped></style>
